import styled from 'styled-components';

// Assets

// Interface

export const Container = styled.img`
  margin-bottom: 8px;
`;
